<template>
    <footer class="footer">
        <button class="btn btn_black" v-on:click="prevStep()" v-if="footerStatus.type == 'config' && (footerStatus.status!= 'start')">上一步</button>
        <button v-bind:class="{endBtn:footerStatus.status== 'end'}" class="btn btn_bg" v-on:click="nextStep()">{{showText}}</button>
    </footer>
</template>

<script>
export default {
    name:'PageFooter',
    props:['footerStatus','prev','next'],
    computed:{
      showText:function(){
        if(this.footerStatus.type == 'config'){
          if(this.footerStatus.status == 'end'){
            return '重新设定模型';
          }else{
            return '下一步';
          }
        }
      }
    },
    data(){
        return{
        }
    },
    methods:{
      nextStep:function(){
        this.$router.push(this.next);
      },
      prevStep:function(){  
         this.$router.push(this.prev);
      }
    }
}
</script>
<style scoped>
.footer {
  height: 0.66rem;
  background-color: #262626;
  box-shadow: 0 10px 25px #000;
  position: fixed;
  bottom: 0;
  width: 100%;
  line-height: 0.66rem;
}
.btn {
  width: 1.88rem;
  height: 0.46rem;
  border-radius: 5px;
  border: 0;
  cursor: pointer;
  outline: none;
  margin-top: 0.1rem;
  line-height: 0.46rem;
}
.btn_bg,.btn_black:hover{
  background-color: #fa5400;
  color: #fff;
}
.btn_black,.btn_black:hover ~.btn_bg{
  color:#fff;
  background-color: #262626;
  border:0;
}
.endBtn{
  background-color: #262626;
  border: 1px solid #FA5400;
  color: #FA5400;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PageFooter.vue